import {
  Icon,
  Typography,
  TextField,
  styled,
} from '@nextiva/next-ui-components';

export const StyledLicenseAmountContainer = styled('div')`
  display: flex;
  justify-content: space-between;
`;
export const StyledBoxIconContainer = styled('div')`
  background-color: ${({ theme }) => theme.palette.secondary.main};
  height: 40px;
  min-width: 40px;
  max-width: 40px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const StyledBoxIcon = styled(Icon)`
  fill: #758ba3;
  transform: scale(1.3);
`;
export const StyledLicenseNameText = styled(Typography)`
  margin: 0px 145px 0px 16px;
  font-weight: 800;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  line-height: 20px;
  color: ${({ theme }) => theme.palette.secondary.contrastText};
`;
export const StyledQuantityField = styled(TextField)`
  min-width: 55px;
  max-width: 55px;
`;
export const StyledXText = styled(Typography)`
  margin: 0px 16px 0px 16px;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  line-height: 20px;
  color: ${({ theme }) => theme.palette.secondary.contrastText};
`;
export const StyledPriceText = styled(Typography)`
  margin-right: 17px;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  line-height: 20px;
  color: ${({ theme }) => theme.palette.secondary.contrastText};
`;
export const StyledTrashIcon = styled(Icon)`
  fill: #758ba3;
  transform: scale(0.94);
`;
export const StyledFlexItem = styled('div')`
  display: flex;
  align-items: center;
`;
